import { CheckableField, FormField } from '@msaf/core-react'

interface NoDrillingTestsInterface {
  isChecked?: boolean
  handleNoTestsCheckbox?: (checked: boolean) => void
  isViewMode?: boolean
}

export default function NoDrillingTests({ isChecked, handleNoTestsCheckbox, isViewMode }: NoDrillingTestsInterface) {
  return (
    <>
      {isViewMode ? (
        <p>There is no yield drawdown information available for this record</p>
      ) : (
        <FormField label='No yield drawdown tests have been added.' labelId='noYieldDrawDownTestsLabelId'>
          <CheckableField
            type='checkbox'
            id='noYieldDrawDownTestsId'
            name='noYieldDrawDownTests'
            describedBy='noYieldDrawDownTestsLabelId'
            label='There is no yield drawdown information available for this record'
            checked={!!isChecked}
            onChange={(e) => handleNoTestsCheckbox && handleNoTestsCheckbox(e.target.checked)}
          />
        </FormField>
      )}
    </>
  )
}
